var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScalesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "85px",
    viewBox: "0 0 91 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-bmi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "-2.34186466%",
    x2: "0%",
    y2: "93.9453125%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "64.1536022%",
    x2: "19.6413923%",
    y2: "30.9674448%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "99.1686022%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0114637305 0.0134868267 1.35858899 0.0134868267 1.35858899 4.88882055 0.0114637305 4.88882055"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 11.2490515 16.4025 11.2490515 16.4025 0 0 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 16.875,
    cy: 35.15625,
    r: 8.4375
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.6%",
    y: "-23.7%",
    width: "159.3%",
    height: "159.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 73.125,
    cy: 35.15625,
    r: 8.4375
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.6%",
    y: "-23.7%",
    width: "159.3%",
    height: "159.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 16.875,
    cy: 66.09375,
    r: 8.4375
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.6%",
    y: "-23.7%",
    width: "159.3%",
    height: "159.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-13",
    cx: 73.125,
    cy: 66.09375,
    r: 8.4375
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.6%",
    y: "-23.7%",
    width: "159.3%",
    height: "159.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-6",
    transform: "translate(-199.000000, -1157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(61.000000, 1062.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-bmi",
    transform: "translate(138.200000, 95.325058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 90,
    height: 84.375,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 42.1875,
    y: 75.9375,
    width: 5.625,
    height: 1.40625,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    x: 30.9375,
    y: 5.625,
    width: 28.125,
    height: 19.6875,
    rx: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75,7.03125 L56.25,7.03125 C57.0266504,7.03125 32.34375,23.2766504 32.34375,22.5 L32.34375,8.4375",
    id: "Rectangle",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(36.562500, 9.843750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.680095433,5.65106996 C0.890341335,5.85104069 1.09555504,6.04252781 1.29515691,6.2397058 C1.327774,6.27192769 1.35248712,6.32912617 1.35261885,6.37489022 C1.35578044,7.46706235 1.35549063,8.55923448 1.35335656,9.65143296 C1.35327752,9.69087383 1.33949824,9.74148566 1.3130726,9.7679113 C1.06844438,10.0125132 0.819653396,10.2529259 0.567595433,10.4988978 C0.240317916,10.2218369 -0.0102119438,9.9323668 0.000326697892,9.45928718 C0.0228530445,8.44657641 0.00862587822,7.43299619 0.00493735363,6.41975849 C0.00459484778,6.32272395 0.0336288056,6.25704186 0.104211358,6.19309865 C0.298622951,6.01689256 0.486869438,5.83383636 0.680095433,5.65106996",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4761186,10.4968112 C10.3511039,10.375933 10.2320436,10.2715741 10.1258141,10.1555173 C9.96365076,9.97838905 9.91145814,9.76216247 9.91218815,9.52456879 C9.91538378,8.48501083 9.9121168,7.44545287 9.91696458,6.40592125 C9.91728074,6.34129303 9.95092535,6.26125205 9.99626786,6.21514549 C10.1835659,6.02471224 10.3813762,5.8445805 10.5858785,5.6506695 C10.8032117,5.85751669 11.018964,6.06033285 11.2303165,6.26762793 C11.2535805,6.29044409 11.2601145,6.33894819 11.2601672,6.37556996 C11.2616689,7.4677421 11.2618006,8.55994057 11.2596666,9.6521127 C11.2595875,9.69147453 11.2453867,9.74192828 11.2189084,9.76838027 C10.9743065,10.0129558 10.7255419,10.2533686 10.4761186,10.4968112",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73762646,0.608319379 C5.47916628,0.844911885 5.2319034,1.07425907 4.97981909,1.29815252 C4.94878279,1.32571107 4.89187412,1.33451083 4.84692681,1.33458987 C3.78096956,1.33656587 2.7150123,1.33661856 1.64905504,1.3343791 C1.60500351,1.33430006 1.54856909,1.32168004 1.51892916,1.29312032 C1.29506206,1.07747336 1.07646429,0.856346311 0.84134719,0.622125 C1.04115984,0.442730972 1.22208197,0.257303571 1.42792799,0.105757904 C1.52195902,0.0365190281 1.66491569,0.00645755269 1.78608372,0.00553542155 C2.79494789,-0.00221048009 3.8038911,-5.0058548e-05 4.81280796,0.00160977752 C5.04713466,0.00200497658 5.2489233,0.0842854215 5.40929508,0.261281909 C5.51215222,0.374835773 5.6197781,0.484095141 5.73762646,0.608319379",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7504947,0.627215164 C10.9240925,0.463945258 11.0834104,0.313453454 11.243466,0.163831089 C11.369034,0.0464569672 11.5228454,0.0019838993 11.6899619,0.00179947307 C12.7032787,0.000697442554 13.7165954,-0.000150175644 14.7299122,0.00219467213 C14.9593648,0.00272160422 15.1567535,0.0867409251 15.3139374,0.259574649 C15.4195609,0.37571048 15.529558,0.487841628 15.6437968,0.608271956 C15.386733,0.843678864 15.1397336,1.07281528 14.8879918,1.29660334 C14.8567974,1.32429362 14.8004157,1.33443706 14.7556792,1.33454245 C13.6897219,1.33657114 12.6237383,1.33659748 11.557781,1.33446341 C11.513466,1.33435802 11.4565574,1.32318706 11.4269701,1.29478542 C11.2025761,1.07950732 10.9835568,0.858617389 10.7504947,0.627215164",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64550293,10.6500799 C5.49648653,10.7889529 5.33440222,10.942659 5.16928806,11.0929927 C5.05017506,11.2014353 4.90389871,11.2463563 4.74605621,11.2465934 C3.71956616,11.2481215 2.69304977,11.2484376 1.66655972,11.2466461 C1.48550585,11.2463299 1.3202863,11.1901853 1.18673536,11.0629839 C1.0471774,10.9300653 0.911387002,10.7931947 0.737025176,10.6217046 C0.781788056,10.5983879 0.821676815,10.5859259 0.850842506,10.560923 C0.970666862,10.4581449 1.10226815,10.3640085 1.20201639,10.243868 C1.43594789,9.96203835 1.72541803,9.89741013 2.08201932,9.90710568 C2.9499555,9.93079128 3.81902459,9.91951493 4.68751405,9.91097863 C4.86685539,9.90921341 5.00443735,9.94609865 5.12355035,10.0865787 C5.28481792,10.2768276 5.46205152,10.4535606 5.64550293,10.6500799",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5467465,10.6557787 C15.3979672,10.793466 15.2400457,10.9682758 15.052853,11.1021165 C14.9391674,11.1833694 14.7806399,11.2398829 14.6415299,11.2414374 C13.6195451,11.2528718 12.5973759,11.2484982 11.5752594,11.2467857 C11.3841411,11.2464696 11.2139157,11.1829479 11.0749637,11.0473156 C10.9432043,10.9187178 10.8123407,10.7891715 10.6374256,10.6171282 C10.683743,10.596209 10.7265826,10.5873566 10.755195,10.5623009 C10.9695773,10.374397 11.1777945,10.1792477 11.3960761,9.99603337 C11.450113,9.95069087 11.5338689,9.91852166 11.6041352,9.9182055 C12.6437722,9.91330504 13.6834619,9.91304157 14.7230989,9.91867974 C14.7958683,9.91907494 14.8865269,9.95627635 14.9378238,10.0074941 C15.1450925,10.2144731 15.3401891,10.4336241 15.5467465,10.6557787",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92207904,0.745827576 C6.15290164,0.96513671 6.41570902,1.14658577 6.47651698,1.48145111 C6.48897892,1.54997863 6.49472248,1.62066657 6.49480152,1.69035334 C6.49593443,2.73907992 6.49630328,3.78783285 6.49353689,4.83655943 C6.49340515,4.88790896 6.47764988,4.95319584 6.44424239,4.98821048 C6.2505685,5.19129011 6.04941218,5.38720345 5.8382178,5.59808167 C5.65674239,5.42582758 5.48269672,5.247988 5.29447658,5.08672043 C5.18044848,4.98900088 5.14451171,4.88379889 5.14546019,4.7355202 C5.15202049,3.69996692 5.15001815,2.6643873 5.14701464,1.62880767 C5.14675117,1.538149 5.17099005,1.47407406 5.23754157,1.41129011 C5.46680972,1.19503718 5.6900445,0.972408372 5.92207904,0.745827576",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(15.043911, 0.710410)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.823225995,0.0182555621 C0.930930913,0.139608021 1.04013759,0.259669496 1.1459719,0.382629098 C1.28882319,0.548612705 1.35890515,0.741074649 1.35859006,0.961727459 C1.35716628,2.01922746 1.35843091,3.07675381 1.35650761,4.13425381 C1.35642857,4.17870053 1.34794496,4.23632055 1.32001756,4.26538085 C1.12009953,4.47367711 0.91412178,4.67612441 0.70168911,4.88882055 C0.476662763,4.674649 0.256826698,4.46793355 0.0413905152,4.25671282 C0.0182845433,4.23405474 0.0125936768,4.18531352 0.0125409836,4.1486654 C0.0110919204,3.05604537 0.0109601874,1.96342535 0.0130415691,0.870805328 C0.0130942623,0.831180035 0.0267944965,0.781648419 0.0525087822,0.753562939 C0.280459602,0.504692916 0.512573185,0.259669496 0.743448478,0.0134868267 C0.770032201,0.015067623 0.796642272,0.0166747658 0.823225995,0.0182555621",
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.87126434,10.4722799 C5.61609748,10.2048618 5.40271633,9.98439344 5.19449912,9.75918267 C5.16607114,9.72843618 5.15089549,9.67384602 5.15079011,9.63024239 C5.14844526,8.54652752 5.1484716,7.46281265 5.15065837,6.37909778 C5.15076376,6.33528337 5.16338378,6.27929684 5.19175907,6.24965691 C5.4006613,6.03150703 5.61504362,5.81865281 5.83506411,5.59670902 C6.04949912,5.82126112 6.25603015,6.03464227 6.45773975,6.25250234 C6.48332231,6.28013993 6.49404537,6.3311733 6.49407172,6.37137822 C6.49517828,7.40682611 6.49209573,8.442274 6.49446941,9.4777219 C6.49499385,9.71254918 6.41187032,9.89802927 6.23987968,10.0585591 C6.1090161,10.180702 5.99986212,10.3260826 5.87126434,10.4722799",
    id: "Fill-18",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7810995,10.4759842 C15.5221388,10.2045615 15.3087313,9.98411944 15.1005141,9.75882963 C15.0721124,9.72813583 15.0572002,9.67344028 15.0571212,9.62978396 C15.0547763,8.54606909 15.0549344,7.46235422 15.0566206,6.37863934 C15.0566733,6.33803923 15.0638923,6.28516159 15.0893431,6.25886768 C15.3022763,6.03858372 15.5202681,5.82317389 15.7438191,5.59917506 C15.956041,5.8214877 16.1626247,6.03494789 16.3643607,6.25286066 C16.3898905,6.2804719 16.4003765,6.33158431 16.4004028,6.37184192 C16.401483,7.40726347 16.3984268,8.4427377 16.4008005,9.47815925 C16.4013249,9.71306557 16.317332,9.89796604 16.1460263,10.0589965 C16.0156633,10.1815609 15.9083273,10.3286276 15.7810995,10.4759842",
    id: "Fill-20",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.607463115,0.840061475 C0.853382319,1.0683548 1.08631265,1.28118267 1.31365749,1.49983314 C1.34242799,1.52749707 1.35333548,1.5855123 1.35341452,1.62951112 C1.35554859,2.704637 1.35560129,3.77978923 1.35323009,4.85494145 C1.35315105,4.898387 1.33797541,4.9527137 1.30967916,4.98343384 C1.10496604,5.2056411 0.895088993,5.42307963 0.679600117,5.64966042 C0.462925644,5.42234192 0.249939696,5.20189988 0.0419596019,4.97682084 C0.0166141686,4.94939403 0.00865749415,4.89709602 0.00863114754,4.85631148 C0.00818325527,3.82505269 0.012530445,2.79382026 0.00915807963,1.76258782 C0.00842037471,1.53576991 0.085352459,1.35624415 0.250097775,1.20346019 C0.381778103,1.08137002 0.502550937,0.947502927 0.607463115,0.840061475",
    id: "Fill-22",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5859312,5.64956294 C10.3700208,5.42321926 10.1596168,5.20614959 9.954851,4.98391598 C9.92676552,4.95343296 9.9152784,4.89715662 9.9152257,4.85281528 C9.91430357,3.82598273 9.91894057,2.79909748 9.91505971,1.77226493 C9.91417184,1.54094174 9.98928601,1.35680533 10.1587474,1.20083343 C10.2906121,1.07948097 10.4102257,0.944770785 10.5137152,0.838225117 C10.7607673,1.06854713 10.9984663,1.28775088 11.2318972,1.5114072 C11.2550559,1.53361739 11.2601672,1.58301727 11.2602198,1.61982348 C11.2616689,2.69934924 11.2620641,3.77890135 11.2590869,4.85840076 C11.2589552,4.90482348 11.2363762,4.9616531 11.2049183,4.995851 C11.0058961,5.21207758 10.8014201,5.42327196 10.5859312,5.64956294",
    id: "Fill-24",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "7.55054157 11.240805 8.88528689 11.240805 8.88528689 9.92647834 7.55054157 9.92647834"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalesIcon);
export default __webpack_public_path__ + "static/media/scales-icon.ef0168b15e48d3841bc58c4900274c7f.svg";
export { ForwardRef as ReactComponent };